import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import SceneBuilderContainer from '../../../sceneBuilderManager';


const SceneBuilderModal = (props: any) => {
    const { isOpen, onOpen, onClose } = useDisclosure()

    return (
        <>
            <Button size={'sm'} variant='outline' colorScheme='blue' onClick={onOpen} >
                Scene Builder
            </Button>
            <Modal size={'full'} closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Scene Builder</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>
                        <SceneBuilderContainer builderStore={props.builderStore} source={'Builder'}  currentProjectId={props.projectId} handleClose={onClose}/>
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme={'brand'} onClick={onClose}>Cancel</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}

SceneBuilderModal.propTypes = {
    projectId: PropTypes.string,
    builderStore:PropTypes.any
}

export default SceneBuilderModal